namespace SorAraBul.Administration {
    export class LanguageColumns {
        static columnsKey = 'Administration.Language';
    }
}
